import type { AbsolutePath } from "shelving";
import { MediaThumbs, Page } from "shared/react";
import { MESSAGES_MAX } from "shared/schema";
import { EntityCards } from "../entity/EntityCard.js";
import { EmbedMarkup } from "../misc/EmbedMarkup.js";
import { useItem } from "../util/db.js";
import { LoadGroupContext } from "./GroupContext.js";
import { GroupShortHeader } from "./GroupShortHeader.js";
import { MessageHeader } from "./Message.js";
import { PossibleMessageForm } from "./MessageForm.js";
import { MessageList } from "./MessageList.js";

export function MessagePage({ id }: { id: string }): React.ReactElement {
	const message = useItem("message", id);
	const { gid, content, images, links } = message.data;
	const path: AbsolutePath = `/message/${id}`;
	return (
		<Page title="Message" path={path}>
			<LoadGroupContext gid={gid}>
				<GroupShortHeader />
				<article>
					<MessageHeader {...message.data} />
					<MediaThumbs paths={images} />
					<section className="space-xsmall">
						<EmbedMarkup>{content}</EmbedMarkup>
					</section>
					<EntityCards entities={links} />
				</article>
				<hr />
				<section className="flex-column flex-reverse">
					<MessageList //
						query={{
							gid,
							thread: id,
							$order: "!date",
							$limit: MESSAGES_MAX,
						}}
						more="Show more replies"
						empty="No replies yet"
					/>
					<PossibleMessageForm thread={id} />
				</section>
			</LoadGroupContext>
		</Page>
	);
}
